import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMoon,
  faStar,
  faSquare,
  faSun,
  faCloudSun,
  faCloud
} from '@fortawesome/free-solid-svg-icons';

const themeIcons = {
  'monkey': faMoon,
  'dracula': faSquare,
  'synth-wave': faStar,
  'solarize': faSun,
  'horizon': faCloudSun,
  'tomorrow': faCloud
};

export default function ThemeButton({ theme, selected, onClick }) {
  return (
    <div
      className={`theme-btn btn-${theme} ${selected ? 'selected' : ''}`}
      onClick={onClick}
      title={theme}
    >
      <FontAwesomeIcon icon={themeIcons[theme]} />
    </div>
  );
}
